import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { IssueTypes } from 'src/app/lib/shared/globals';
import { DefaultMail } from '../../../classes';
import { ISSUE_PROVIDER_SERVICE } from '../../../interfaces';

@Component({
  selector: 'app-issue-transaction-form',
  templateUrl: './issue-transaction-form.component.html',
  styleUrls: ['./issue-transaction-form.component.css'],
  providers: [
    { provide: ISSUE_PROVIDER_SERVICE, useExisting: IssueTransactionFormComponent }
  ]
})
export class IssueTransactionFormComponent implements OnDestroy, OnInit {

  @Input() appearance: 'fill' | 'outline' | 'standard' = 'fill';

  public formGroup: FormGroup;

  private _issueStatus = new BehaviorSubject(IssueTypes.Issue);
  
  private _subscriptions: Subscription[] = [];

  constructor(
    private _controlContainer: ControlContainer,
    private _formBuilder: FormBuilder
  ) { }

  addMail(){
    var mail = new DefaultMail();
    let formGroup = this._formBuilder.group(mail);
    formGroup.markAsDirty();
    (this.formGroup.controls['defaultMails'] as FormArray).push(formGroup);
  }

  getCurrentIssueType() {
    return this._issueStatus.asObservable();
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;

    this._subscriptions.push(...[
      this.formGroup.controls['issueType'].valueChanges.subscribe(this._issueStatus)
    ]);
  }

  get guidControl(): AbstractControl {
    return (this.formGroup.controls['issueTransaction'] as FormGroup).controls['guid'];
  }
  get defaultMailArray(): FormArray {
    return this.formGroup.controls['defaultMails'] as FormArray;
  }

}
